
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/update-browser",
      function () {
        return require("private-next-pages/update-browser/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/update-browser"])
      });
    }
  